import {TitleNav, Page, HCThemeType} from '@hconnect/uikit'
import {makeStyles} from '@material-ui/core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {RmcOrderIntakeProcessProvider} from '../../features/rmc/orderIntake'
import Content from '../../Molecules/Content'
import SubHeader from '../../Molecules/SubHeader'

const useStyles = makeStyles((theme: HCThemeType) => {
  return {
    pageStyle: {
      [theme.breakpoints.up('md')]: {
        padding: `${theme.spacing(4)}px`
      },
      padding: 0
    }
  }
})

const RmcDeliveryOrderIntake: React.FC = () => {
  const {t} = useTranslation()
  const history = useHistory()
  const classes = useStyles()

  return (
    <Content>
      <SubHeader>
        <TitleNav title={t('overview.scheduleNewDelivery')} onClick={() => history.goBack()} />
      </SubHeader>
      <Page data-test-id="rmc-delivery-order-intake-page" className={classes.pageStyle}>
        <RmcOrderIntakeProcessProvider />
      </Page>
    </Content>
  )
}

export {RmcDeliveryOrderIntake}
